import { createSignal } from "solid-js"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"
import { ActionLog } from "../../lib/core/state/flux/ActionLog.type"

export const useActionLogsSignal = createSharedCachedFactory((
  // engine: Engine
) => {

  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<Array<ActionLog>>([])

  return signal
})
